<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatterPage" id="fm01"><div class="chapterHead"><h2 class="chapterTitle" style="text-indent: 0%"> </h2></div><div class="chapterBody"><p class="chapterOpenerText" style="text-indent: 0%"><span><span class="chapterOpenerFirstLetters"><span><span class="bold"><span>“O</span></span></span></span>nly you can save your own life.”</span></p><p class="para" style="text-indent: 5%"><span>Everyone told me this in one version or another, during the very bleak days after Scott and I fell apart. I took the advice to heart. I did everything I could to rescue myself.</span></p><p class="para" style="text-indent: 5%"><span>I prayed to a divinity I couldn’t see or feel. I logged hours on the couch. I cleansed. I twisted my body into awkward positions intended to purify. I scribbled and scrawled in journals. I read Goethe. I slept and wept. I watched comedies and dramas. I swore off TV. I ate organically. I drank toxically. I took up gardening. I ran until my legs could hardly hold me.</span></p><p class="para" style="text-indent: 5%"><span>Nothing helped. The problem was I no longer really wanted to save my own life. Someone had to do it for me. That someone was Liza.</span></p><p class="para" style="text-indent: 5%"><span>But even Liza had no idea what it would take to save me.</span></p></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// goodliarthe_fm01.vue?e3e2e58c